<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" icon class="">
      <v-icon small light class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Location</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedLocations" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-card-text>
            <v-flex xs12>
            <v-text-field
              name="editedLocations.locationName"
              label="Name"
              v-model="editedLocations.locationName"
              id="locationName"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="editedLocations.locationStreetAddress"
              label="Stree Address"
              v-model="editedLocations.locationStreetAddress"
              id="locationStreetAddress"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="editedLocations.locationCity"
              label="City"
              v-model="editedLocations.locationCity"
              id="locationCity"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="editedLocations.locationState"
              label="State"
              v-model="editedLocations.locationState"
              id="locationState"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="editedLocations.locationZipcode"
              label="Zipcode"
              v-model="editedLocations.locationZipcode"
              id="locationZipcode"
              single-line
              required
            ></v-text-field>
          </v-flex>
          </v-card-text>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text primary " @click="onSaveChanges">Save</v-btn>
              <v-btn dark flat class="red darken-3" @click="onDeleteLocation(location)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['location'],
  data () {
    return {
      editDialog: false,
      editedLocations: this.location,
      holder: []
    }
  },
  computed: {
    loadLocations () {
      return this.$store.getters.loadedLocations
    }
  },
  methods: {
    onDeleteLocation (location) {
      console.log('Delete this: ' + JSON.stringify(location))
      this.$store.dispatch('deleteLocationData', location)
      this.$router.push('/locations')
    },
    onSaveChanges () {
      this.editDialog = false
      console.log(this.location.locationId)
      this.$store.dispatch('updateLocationData', {
        locationId: this.location.locationId,
        locations: this.editedLocations
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditLocationsDialog.vue?d2429172